import {api} from "./api.service";

export class VaultService {
    static async getVault(type= '', page=0, limit=0, excludedId = '', search='', filters={}) {
        const params = {}
        if(type)
            params['type'] = type
        if(page)
            params['page'] = page
        if(limit)
            params['limit'] = limit
        if(excludedId)
            params['excludedId'] = excludedId
        if(search)
            params['search'] = search
            
        // Add filter parameters if provided
        if(filters) {
            if(filters.start_date)
                params['start_date'] = filters.start_date
            if(filters.end_date)
                params['end_date'] = filters.end_date
            if(filters.partially_watched)
                params['partially_watched'] = filters.partially_watched
            if(filters.fully_watched)
                params['fully_watched'] = filters.fully_watched
        }

        return api.get(`vault`, {params});
    }
    static async getSingleVault(id) {
        return  api.get(`vault/${id}`);
    }
    static async TrackVideoProgress(payload) {
        let res = await api.post(`vault-watch-history`, payload);
        return res;
    }
    static async getVaultTags(sort= '_id') {
        const params = {}
        if(sort)
            params['sort'] = sort

        return  api.get(`vault/tags`, {params});
    }
}
